export default __webpack_public_path__ + "static/media/popup-bg-mobile.8156af42.jpg";